import { Popper, TextField } from "@mui/material";
import React from "react";
import AppAutoComplete from "./AppAutoComplete";

const CustomPopper = (props) => {
  return (
    <Popper
      {...props}
      modifiers={[
        {
          name: "offset",
          options: {
            offset: [0, 4],
          },
        },
        {
          name: "preventOverflow",
          options: {
            padding: 8,
          },
        },
      ]}
      style={{
        ...props.style,
        minWidth: props.anchorEl?.clientWidth, // Set min-width equal to Autocomplete width
        maxWidth: "max-content", // Allow it to grow with content
        textTransform: "capitalize",
      }}
    />
  );
};
const AppDynamicComponents = ({
  type,
  name,
  label,
  onChange = () => {},
  onBlur = () => {},
  value,
  error,
  touched,
  options,
  disableClearable,
}) => {
  switch (type) {
    case "text":
      return (
        <TextField
          name={name}
          label={label}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          error={error && touched}
          helperText={error && touched ? error : null}
          variant="outlined"
          fullWidth
        />
      );

    case "dropdown":
      return (
        <AppAutoComplete
          name={name}
          label={label}
          options={options}
          getOptionLabel={(option) => option.label}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          disableClearable={disableClearable}
          PopperComponent={CustomPopper}
          valueParam="value"
          error={error}
          touched={touched}
        />
      );

    default:
      return null;
  }
};

export default AppDynamicComponents;
